import React from "react";
import { DatePicker, Form, Select, Button, notification } from "antd";
import { newJob } from '../../../store/models/Jobs/jobsAPI';
import _ from 'lodash';

const Option = Select.Option;

notification.config({
    placement: 'topLeft',
});

class CatForm extends React.Component {
    constructor(props) {
        super(props);
        this.displayResults = this.displayResults.bind(this);
        this.reloadJobsList = this.reloadJobsList.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    reloadJobsList() {
        this.props.loadAllJobs3();
    }

    displayResults(results) {
        notification.open({
            message: 'Success',
            description:
                'A new Categorization Job has been created.',
        });
        let reloadJobs = this.reloadJobsList();
        setTimeout(function(){reloadJobs();}, 1500);
    }

    handleSubmit(e) {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                let data = {};
                let now = new Date();
                data.dateBegin = values.Date._d;
                data.dateEnd = now.toISOString();
                data.jobType = "BOTH";
                data.categories = values.Categories;
                newJob(JSON.stringify(data), this.props.bearerToken).then(this.displayResults);
                this.props.setDrawerVisible(false);
            }
        });
    };

    disabledDate(current) {
      const today = new Date();
      const start = (new Date()).setMonth(today.getMonth() - 3);
      return !current || current > today || current < start;
    };

    render() {
        const { getFieldDecorator } = this.props.form;
        const categories = _.get(this,"props.categories",[]);

        return (
            <Form onSubmit={this.handleSubmit} layout={"vertical"} style={{padding: '20px', position: 'relative'}}>

                <Form.Item label="From Date:" >
                    {getFieldDecorator('Date', {
                        rules: [{ required: true, message: 'Please choose a From Date!' }],
                    })(
                        <DatePicker format={"MM/DD/YYYY"} disabledDate={this.disabledDate} />,
                    )}
                </Form.Item>

                <Form.Item label="Categories:" >
                    {getFieldDecorator('Categories', {
                        rules: [{ required: true, message: 'Please select at least one Category!' }],
                    })(
                        <Select
                            mode="multiple"
                            style={{width: '100%', cursor: 'pointer'}}
                            placeholder="Please select Categories"
                            allowClear={true}
                            onChange={this.handleSelectChange}
                        >{categories.filter(cat => (cat.active)).map((element, index) => {
                                let desc = _.get(element,"categoryDescription",element.notes);
                                return (<Option value={element.categoryName} style={{borderBottom: '1px solid #DDDDDD'}}
                                                key={index}>{element.categoryName}
                                    <div>{desc}</div>
                                </Option>);
                            })
                            }
                        </Select>,
                    )}
                </Form.Item>
                <Form.Item style={{position:'absolute', bottom: '0px', width: '90%'}}>
                    <Button style={{float:'right'}} type="primary" htmlType="submit">Run</Button>
                </Form.Item>

            </Form>
        );
    }
}

const WrappedCatForm = Form.create({ name: 'Cat_Form' })(CatForm);

export default WrappedCatForm;
